<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <a
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Linha do Tempo' : 'Cadastrar Linha do Tempo' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <!-- Title -->
                  <CCol lg="8">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      :disabled="processing"
                    />
                  </CCol>

                  <!-- Year -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.year"
                      v-mask="'####'"
                      label="Ano*"
                      type="number"
                      :disabled="processing"
                      :placeholder="`Ex: ${new Date().getFullYear()}`"
                    />
                  </CCol>

                  <!-- Description -->
                  <CCol col="12">
                    <div class="form-group">
                      <label for="description">Descrição</label>

                      <TextEditor
                        id="description"
                        v-model="form.description"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>

                  <!-- Image -->
                  <CCol col="12">
                    <FileUploader
                      id="timeline-image"
                      :enable-multiple="false"
                      :uploader-info="uploaderInfo"
                      :enable-crop-on-uploader="true"
                      :enable-edit-on-api-table="false"
                      :max-files="1"
                      :accept-types="acceptTypes"
                      :extensions="extensions"
                      :medias="form.main_image"
                      :min-cropped-width="427"
                      :min-cropped-height="291"
                      uploader-type="banner"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <label for="english-description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.description_en"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <label for="spanish-description">Descrição*</label>

                      <TextEditor
                        id="spanish-description"
                        v-model="form.description_es"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import TextEditor from '@/components/ui/TextEditor'
import TabsStatus from '@/components/ui/TabsStatus'
import CardLog from '@/components/ui/CardLog'

import { cloneDeep } from 'lodash'
import moment from 'moment'

// Services
import Service from '@/services/timeline.service'

export default {
  metaInfo: {
    title: 'Linha do Tempo',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_timelines')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    TextEditor,
    TabsStatus,
    CardLog
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      vertical: false,
      variant: 'tabs',
      item: {
        status: true,
        title: '',
        year: '',
        description: '',
        main_image: [],
        title_en: '',
        description_en: '',
        status_en: false,
        title_es: '',
        description_es: '',
        status_es: false
      },
      form: {},
      status: true,
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      imageMedia: [],
      processing: false,
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      activeTabIndex: 0,
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: data.id,
            status: !!data.status,
            main_image_id: data.main_image_id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            year: data.year,
            description: data.description,
            description_en: data.description_en,
            description_es: data.description_es,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            main_image: data.main_image
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        status: this.form.status,
        title: this.form.title,
        year: this.form.year,
        description: this.form.description,
        title_en: this.form.title_en,
        description_en: this.form.description_en,
        status_en: this.form.status_en,
        title_es: this.form.title_es,
        description_es: this.form.description_es,
        status_es: this.form.status_es,
        main_image_id: this.form.main_image && this.form.main_image.length > 0 ? this.form.main_image[0].id : null
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Linha do tempo foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Linha do tempo foi cadastrada com sucesso!'
      }

      this.processing = false
      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
